import { EcomOrderStatusEnum } from 'src/enums';

export const ecomOrderStatus: string[] = [
  EcomOrderStatusEnum.Pending,
  EcomOrderStatusEnum.Paid,
  EcomOrderStatusEnum.Expired,
  EcomOrderStatusEnum.COD,
  EcomOrderStatusEnum.Processing,
  EcomOrderStatusEnum.Completed,
  EcomOrderStatusEnum.Cancelled,
  EcomOrderStatusEnum.Refunded
];
